import React from 'react';

const CircleFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2"
        />
    </svg>
);

CircleFillSvg.displayName = 'CircleFillSvg';
export default CircleFillSvg;
